import { call, put, select, takeEvery } from "redux-saga/effects"

import { genericGetRequest_2 } from "helpers/sf_backend_helper.js"

import { AppConfiguration } from "config"
import { bsh_getAdminUserDetails } from "helpers/sf_browser_storage_helper"
import { buildCampaignAnalysisCacheKey } from "helpers/sf_utils"
import { getAdminIntegrationLogsError, getAdminIntegrationLogsSuccess } from "./actions";
import { GET_ADMIN_INTEGRATION_LOGS } from "./actionTypes";

const inFlightAdminIntegrationLogsRequests = new Set()

function* onGetAdminIntegrationLogs(action) {
  try {
    const useCache = Boolean(action.payload?.useCache)
    const queryParams = action?.payload?.queryParams || {}
    const requestedPageNumber = parseInt(queryParams.page_number, 10) || 1
    const cacheKey = useCache ? buildCampaignAnalysisCacheKey(queryParams) : null
    const requestKey = `${cacheKey}:${requestedPageNumber}`
    const cachedPage = useCache
      ? yield select((state) => state.AdminIntegrationLogs.page_cache?.[cacheKey]?.[requestedPageNumber])
      : null

    if (useCache && cachedPage) {
      return
    }

    if (useCache && inFlightAdminIntegrationLogsRequests.has(requestKey)) {
      return
    }

    if (useCache) {
      inFlightAdminIntegrationLogsRequests.add(requestKey)
    }

    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericGetRequest_2,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_integration_logs`,
      queryParams,
      {
        Authorization: user.token,
      }
    )
    yield put(getAdminIntegrationLogsSuccess(response, {
      appendResults: Boolean(action.payload?.appendResults),
      useCache,
      queryParams,
    }))
  } catch (error) {
    yield put(getAdminIntegrationLogsError(error))
  } finally {
    if (action.payload?.useCache) {
      const queryParams = action?.payload?.queryParams || {}
      const requestedPageNumber = parseInt(queryParams.page_number, 10) || 1
      const cacheKey = buildCampaignAnalysisCacheKey(queryParams)
      inFlightAdminIntegrationLogsRequests.delete(`${cacheKey}:${requestedPageNumber}`)
    }
  }
}


function* adminIntegrationLogsSaga() {
  yield takeEvery(GET_ADMIN_INTEGRATION_LOGS, onGetAdminIntegrationLogs)

}

export default adminIntegrationLogsSaga;
